/* import __COLOCATED_TEMPLATE__ from './textarea.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./textarea.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());